import { AnswerInput } from '__generatedTypes__/globalTypes'
import { findOneQuestion_findOneQuestion as Question } from '__generatedTypes__/findOneQuestion'
import { createUuid } from 'utils/uuid'

export type TextCompletionOption = {
  id: string
  value: string
  isCorrect: boolean
}

export type TextCompletionBlank = {
  id?: string
  options: TextCompletionOption[]
}

export const TEXT_COMPLETION_MIN_OPTIONS = 2
export const TEXT_COMPLETION_MAX_OPTIONS = 9
export const TEXT_COMPLETION_FIXED_OPTIONS = 3
export const TEXT_COMPLETION_BLANK_LABELS = ['(i)', '(ii)', '(iii)'] as const

export const TEXT_COMPLETION_BLANK_COUNT_OPTIONS = [
  { id: '1', title: '1' },
  { id: '2', title: '2' },
  { id: '3', title: '3' },
]

export const getTextCompletionBlanksCountOption = (count: number) => ({
  id: String(count),
  title: String(count),
})

export const createTextCompletionOption = (isCorrect = false): TextCompletionOption => ({
  id: createUuid(),
  value: '',
  isCorrect,
})

export const createTextCompletionBlank = (): TextCompletionBlank => ({
  options: [createTextCompletionOption(true), createTextCompletionOption(), createTextCompletionOption()],
})

export const parseTextCompletionAnswerHtml = (textAsHtml: string): Pick<TextCompletionBlank, 'options'> => {
  try {
    const parsed = JSON.parse(textAsHtml) as { options?: TextCompletionOption[] }

    return {
      options: parsed.options ?? createTextCompletionBlank().options,
    }
  } catch (error) {
    console.error('An error ocurred while trying to parse TextCompletion answer', error)
    return { options: createTextCompletionBlank().options }
  }
}

export const convertAnswerToTextCompletionAnswer = (answer?: Question['answer']): TextCompletionBlank[] => {
  const blanks =
    answer?.map(({ id, textAsHtml }) => ({
      id,
      ...parseTextCompletionAnswerHtml(textAsHtml),
    })) ?? []

  return blanks.length ? blanks : [createTextCompletionBlank()]
}

export const serializeTextCompletionAnswers = (blanks?: TextCompletionBlank[]): AnswerInput[] =>
  blanks?.map((blank, index) => ({
    id: blank.id,
    textAsHtml: JSON.stringify({ options: blank.options }),
    isCorrect: true,
    point: 1,
    order: index,
  })) ?? []
